import { LabelField } from 'components/LabelField';
import InfoTooltip from 'components/InfoTooltip';
import Selection from 'components/Selection/Selection';
import React from 'react';

const PaymentGatewaySelection = ({
  options = [],
  formik,
  isLoading,
  view = false,
  className = "",
}) => {
  return (
    <div className={`payment_settings_gateway ${className}`}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
        <LabelField title={"Payment Gateway"} mandatory={true} />
        <InfoTooltip text="Which configured gateway processes this payment type. Limited to Stripe when 'Allow Member' is checked." />
      </div>
      <Selection
        name="paymentGateway"
        mandatory={true}
        placeholder="Select Payment Gateway"
        options={options}
        isLoading={isLoading}
        onChange={(value) => {
          if (!value?.value) {
            formik.setFieldValue("paymentGateway", null);
            if(formik.values?.payement_type_new === "ach") {
              formik.setFieldValue("allow_member", false);
            }
            return;
          }
          formik.setFieldValue("paymentGateway", value);
        }}
        value={formik.values?.paymentGateway}
        isClearable={formik.values?.paymentGateway?.value}
        style="secondary"
        isDisabled={view}
      />
    </div>
  )
}

export default PaymentGatewaySelection